/**
 * @hidden
 * @deprecated
 */
export const created = 'create';
/**
 * @hidden
 * @deprecated
 */
export const destroyed = 'destroy';
/**
 * @hidden
 * @deprecated
 */
export const tableclass = 'tableclass';
/**
 * @hidden
 * @deprecated
 */
export const load = 'load';
/**
 * Specifies Rich Text Editor internal events
 */
/**
 * @hidden
 * @deprecated
 */
export const initialLoad = 'initial-load';
/**
 * @hidden
 * @deprecated
 */
export const contentChanged = 'content-changed';
/**
 * @hidden
 * @deprecated
 */
export const initialEnd = 'initial-end';
/**
 * @hidden
 * @deprecated
 */
export const iframeMouseDown = 'iframe-click';
/**
 * @hidden
 * @deprecated
 */
export const destroy = 'destroy';
/**
 * @hidden
 * @deprecated
 */
export const toolbarClick = 'toolbarClick';
/**
 * @hidden
 * @deprecated
 */
export const toolbarRefresh = 'toolbar-refresh';
/**
 * @hidden
 * @deprecated
 */
export const slashMenuOpening = 'slash-menu-opening';
/**
 * @hidden
 * @deprecated
 */
export const refreshBegin = 'refresh-begin';
/**
 * @hidden
 * @deprecated
 */
export const toolbarUpdated = 'toolbar-updated';
/**
 * @hidden
 * @deprecated
 */
export const bindOnEnd = 'bind-on-end';
/**
 * @hidden
 * @deprecated
 */
export const htmlToolbarClick = 'html-toolbar-click';
/**
 * @hidden
 * @deprecated
 */
export const markdownToolbarClick = 'markdown-toolbar-click';
/**
 * @hidden
 * @deprecated
 */
export const modelChanged = 'model-changed';
/**
 * @hidden
 * @deprecated
 */
export const tableModulekeyUp = 'tableModulekeyUp';
/**
 * @hidden
 * @deprecated
 */
export const keyUp = 'keyUp';
/**
 * @hidden
 * @deprecated
 */
export const keyDown = 'keyDown';
/**
 * @hidden
 * @deprecated
 */
export const onImport = 'onImport';
/**
 * @hidden
 * @deprecated
 */
export const onExport = 'onExport';
/**
 * @hidden
 * @deprecated
 */
export const onCodeBlock = 'onCodeBlock';
/**
 * @hidden
 * @deprecated
 */
export const mouseUp = 'mouseUp';
/**
 * @hidden
 * @deprecated
 */
export const toolbarCreated = 'toolbarCreated';
/**
 * @hidden
 * @deprecated
 */
export const toolbarRenderComplete = 'toolbarRenderComplete';
/**
 * @hidden
 * @deprecated
 */
export const enableFullScreen = 'enableFullScreen';
/**
 * @hidden
 * @deprecated
 */
export const disableFullScreen = 'disableFullScreen';
/**
 * @hidden
 * @deprecated
 */
export const dropDownSelect = 'dropDownSelect';
/**
 * @hidden
 * @deprecated
 */
export const beforeDropDownItemRender = 'beforeDropDownItemRender';
/**
 * @hidden
 * @deprecated
 */
export const execCommandCallBack = 'execCommandCallBack';
/**
 * @hidden
 * @deprecated
 */
export const imageToolbarAction = 'image-toolbar-action';
/**
 * @hidden
 * @deprecated
 */
export const audioToolbarAction = 'audio-toolbar-action';
/**
 * @hidden
 * @deprecated
 */
export const videoToolbarAction = 'video-toolbar-action';
/**
 * @hidden
 * @deprecated
 */
export const linkToolbarAction = 'link-toolbar-action';
/**
 * @hidden
 * @deprecated
 */
export const windowResize = 'resize';
/**
 * @hidden
 * @deprecated
 */
export const resizeStart = 'resizeStart';
/**
 * @hidden
 * @deprecated
 */
export const onResize = 'resizing';
/**
 * @hidden
 * @deprecated
 */
export const resizeStop = 'resizeStop';
/**
 * @hidden
 * @deprecated
 */
export const undo = 'undo';
/**
 * @hidden
 * @deprecated
 */
export const redo = 'redo';
/**
 * @hidden
 * @deprecated
 */
export const insertLink = 'insertLink';
/**
 * @hidden
 * @deprecated
 */
export const unLink = 'unLink';
/**
 * @hidden
 * @deprecated
 */
export const editLink = 'editLink';
/**
 * @hidden
 * @deprecated
 */
export const openLink = 'openLink';
/**
 * @hidden
 * @deprecated
 */
export const actionBegin = 'actionBegin';
/**
 * @hidden
 * @deprecated
 */
export const actionComplete = 'actionComplete';
/**
 * @hidden
 * @deprecated
 */
export const updatedToolbarStatus = 'updatedToolbarStatus';
/**
 * @hidden
 * @deprecated
 */
export const actionSuccess = 'actionSuccess';
/**
 * @hidden
 * @deprecated
 */
export const updateToolbarItem = 'updateToolbarItem';
/**
 * @hidden
 * @deprecated
 */
export const insertImage = 'insertImage';
/**
 * @hidden
 * @deprecated
 */
export const insertAudio = 'insertAudio';
/**
 * @hidden
 * @deprecated
 */
export const insertVideo = 'insertVideo';
/**
 * @hidden
 * @deprecated
 */
export const insertCompleted = 'insertCompleted';
/**
 * @hidden
 * @deprecated
 */
export const imageLeft = 'justifyLeft';
/**
 * @hidden
 * @deprecated
 */
export const imageRight = 'justifyRight';
/**
 * @hidden
 * @deprecated
 */
export const imageCenter = 'justifyCenter';
/**
 * @hidden
 * @deprecated
 */
export const imageBreak = 'break';
/**
 * @hidden
 * @deprecated
 */
export const imageInline = 'inline';
/**
 * @hidden
 * @deprecated
 */
export const imageLink = 'insertImgLink';
/**
 * @hidden
 * @deprecated
 */
export const imageAlt = 'imgAltText';
/**
 * @hidden
 * @deprecated
 */
export const imageDelete = 'delete';
/**
 * @hidden
 * @deprecated
 */
export const audioDelete = 'delete';
/**
 * @hidden
 * @deprecated
 */
export const videoDelete = 'delete';
/**
 * @hidden
 * @deprecated
 */
export const imageCaption = 'caption';
/**
 * @hidden
 * @deprecated
 */
export const imageSize = 'imageSize';
/**
 * @hidden
 * @deprecated
 */
export const videoSize = 'videoSize';
/**
 * @hidden
 * @deprecated
 */
export const sourceCode = 'sourceCode';
/**
 * @hidden
 * @deprecated
 */
export const updateSource = 'updateSource';
/**
 * @hidden
 * @deprecated
 */
export const toolbarOpen = 'toolbarOpen';
/**
 * @hidden
 * @deprecated
 */
export const beforeDropDownOpen = 'beforeDropDownOpen';
/**
 * @hidden
 * @deprecated
 */
export const selectionSave = 'selection-save';
/**
 * @hidden
 * @deprecated
 */
export const selectionRestore = 'selection-restore';
/**
 * @hidden
 * @deprecated
 */
export const expandPopupClick = 'expandPopupClick';
/**
 * @hidden
 * @deprecated
 */
export const count = 'count';
/**
 * @hidden
 * @deprecated
 */
export const contentFocus = 'contentFocus';
/**
 * @hidden
 * @deprecated
 */
export const contentBlur = 'contentBlur';
/**
 * @hidden
 * @deprecated
 */
export const mouseDown = 'mouseDown';
/**
 * @hidden
 * @deprecated
 */
export const sourceCodeMouseDown = 'sourceCodeMouseDown';
/**
 * @hidden
 * @deprecated
 */
export const editAreaClick = 'editAreaClick';
/**
 * @hidden
 * @deprecated
 */
export const scroll = 'scroll';
/**
 * @hidden
 * @deprecated
 */
export const contentscroll = 'contentscroll';
/**
 * @hidden
 * @deprecated
 */
export const colorPickerChanged = 'colorPickerChanged';
/**
 * @hidden
 * @deprecated
 */
export const focusChange = 'focusChange';
/**
 * @hidden
 * @deprecated
 */
export const selectAll = 'selectAll';
/**
 * @hidden
 * @deprecated
 */
export const selectRange = 'selectRange';
/**
 * @hidden
 * @deprecated
 */
export const getSelectedHtml = 'getSelectedHtml';
/**
 * @hidden
 * @deprecated
 */
export const renderInlineToolbar = 'renderInlineToolbar';
/**
 * @hidden
 * @deprecated
 */
export const paste = 'paste-content';
/**
 * @hidden
 * @deprecated
 */
export const codeBlockPaste = 'code-block-paste-content';
/**
 * @hidden
 * @deprecated
 */
export const codeBlockEnter = 'code-block-enter';
/**
 * @hidden
 * @deprecated
 */
export const imgModule = 'imageModule';
/**
 * @hidden
 * @deprecated
 */
export const rtlMode = 'rtl-mode';
/**
 * @hidden
 * @deprecated
 */
export const createTable = 'createTable';
/**
 * @hidden
 * @deprecated
 */
export const updateProperty = 'updateProperty';
/**
 * @hidden
 * @deprecated
 */
export const docClick = 'docClick';
/**
 * @hidden
 * @deprecated
 */
export const tableToolbarAction = 'table-toolbar-action';
/**
 * @hidden
 * @deprecated
 */
export const checkUndo = 'checkUndoStack';
/**
 * @hidden
 * @deprecated
 */
export const readOnlyMode = 'readOnlyMode';
/**
 * @hidden
 * @deprecated
 */
export const clipBoardCleanup = 'clipBoardCleanup';
/**
 * @hidden
 * @deprecated
 */
export const beforeClipboardWrite = 'beforeClipboardWrite';
/**
 * @hidden
 * @deprecated
 */
export const pasteClean = 'pasteClean';
/**
 * @hidden
 * @deprecated
 */
export const enterHandler = 'enterHandler';
/**
 * @hidden
 * @deprecated
 */
export const beforeDialogOpen = 'beforeDialogOpen';
/**
 * @hidden
 * @deprecated
 */
export const clearDialogObj = 'clearDialogObj';
/**
 * @hidden
 * @deprecated
 */
export const dialogOpen = 'dialogOpen';
/**
 * @hidden
 * @deprecated
 */
export const beforeDialogClose = 'beforeDialogClose';
/**
 * @hidden
 * @deprecated
 */
export const dialogClose = 'dialogClose';
/**
 * @hidden
 * @deprecated
 */
export const beforeQuickToolbarOpen = 'beforeQuickToolbarOpen';
/**
 * @hidden
 * @deprecated
 */
export const quickToolbarOpen = 'quickToolbarOpen';
/**
 * @hidden
 * @deprecated
 */
export const quickToolbarClose = 'quickToolbarClose';
/**
 * @hidden
 * @deprecated
 */
export const popupHide = 'popupHide';
/**
 * @hidden
 * @deprecated
 */
export const imageSelected = 'imageSelected';
/**
 * @hidden
 * @deprecated
 */
export const imageUploading = 'imageUploading';
/**
 * @hidden
 * @deprecated
 */
export const imageUploadSuccess = 'imageUploadSuccess';
/**
 * @hidden
 * @deprecated
 */
export const imageUploadFailed = 'imageUploadFailed';
/**
 * @hidden
 * @deprecated
 */
export const imageRemoving = 'imageRemoving';
/**
 * @hidden
 * @deprecated
 */
export const fileSelected = 'fileSelected';
/**
 * @hidden
 * @deprecated
 */
export const fileUploading = 'fileUploading';
/**
 * @hidden
 * @deprecated
 */
export const fileUploadSuccess = 'fileUploadSuccess';
/**
 * @hidden
 * @deprecated
 */
export const fileUploadFailed = 'fileUploadFailed';
/**
 * @hidden
 * @deprecated
 */
export const fileRemoving = 'fileRemoving';
/**
 * @hidden
 * @deprecated
 */
export const afterImageDelete = 'afterImageDelete';
/**
 * @hidden
 * @deprecated
 */
export const afterMediaDelete = 'afterMediaDelete';
/**
 * @hidden
 * @deprecated
 */
export const drop = 'drop';
/**
 * @hidden
 * @deprecated
 */
export const renderQuickToolbar = 'renderQuickToolbar';
/**
 * @hidden
 * @deprecated
 */
export const xhtmlValidation = 'xhtmlValidation';
/**
 * @hidden
 * @deprecated
 */
export const beforeImageUpload = 'beforeImageUpload';
/**
 * @hidden
 * @deprecated
 */
export const beforeFileUpload = 'beforeFileUpload';
/**
 * @hidden
 * @deprecated
 */
export const resizeInitialized = 'resizeInitialized';
/**
 * @hidden
 * @deprecated
 */
export const renderFileManager = 'renderFileManager';
/**
 * @hidden
 * @deprecated
 */
export const beforeImageDrop = 'beforeImageDrop';
/**
 * @hidden
 * @deprecated
 */
export const beforeMediaDrop = 'beforeMediaDrop';
/**
 * @hidden
 * @deprecated
 */
export const dynamicModule = 'dynamicModule';
/**
 * @hidden
 * @deprecated
 */
export const beforePasteCleanup = 'beforePasteCleanup';
/**
 * @hidden
 * @deprecated
 */
export const afterPasteCleanup = 'afterPasteCleanup';
/**
 * @hidden
 * @deprecated
 */
export const updateTbItemsStatus = 'updateTbItemsStatus';
/**
 * @hidden
 * @deprecated
 */
export const showLinkDialog = 'showLinkDialog';
/**
 * @hidden
 * @deprecated
 */
export const closeLinkDialog = 'closeLinkDialog';
/**
 * @hidden
 * @deprecated
 */
export const showImageDialog = 'showImageDialog';
/**
 * @hidden
 * @deprecated
 */
export const showAudioDialog = 'showAudioDialog';
/**
 * @hidden
 * @deprecated
 */
export const showVideoDialog = 'showVideoDialog';
/**
 * @hidden
 * @deprecated
 */
export const closeImageDialog = 'closeImageDialog';
/**
 * @hidden
 * @deprecated
 */
export const closeAudioDialog = 'closeAudioDialog';
/**
 * @hidden
 * @deprecated
 */
export const closeVideoDialog = 'closeVideoDialog';
/**
 * @hidden
 * @deprecated
 */
export const showTableDialog = 'showTableDialog';
/**
 * @hidden
 * @deprecated
 */
export const closeTableDialog = 'closeTableDialog';
/**
 * @hidden
 * @deprecated
 */
export const bindCssClass = 'bindCssClass';
/**
 * @hidden
 * @deprecated
 */
export const formatPainterClick = 'formatPainterClick';
/**
 * @hidden
 * @deprecated
 */
export const formatPainterDoubleClick = 'formatPainterDoubleClick';
/**
 * @hidden
 * @deprecated
 */
export const emojiPicker = 'emojiPicker';
/**
 * @hidden
 * @deprecated
 */
export const destroyTooltip = 'destroyTooltip';
/**
 * @hidden
 * @deprecated
 */
export const hidePopup = 'hidePopup';
/**
 * @hidden
 * @deprecated
 */
export const cleanupResizeElements = 'cleanupResizeElements';
/**
 * @hidden
 * @deprecated
 */
export const afterKeyDown = 'afterKeyDown';
/**
 * @hidden
 * @deprecated
 */
export const updateValueOnIdle = 'updateValueOnIdle';
/**
 * @hidden
 * @deprecated
 */
export const documentClickClosedBy = 'documentClickClosedBy';
/**
 * @hidden
 * @deprecated
 */
export const showColorPicker = 'showColorPicker';
/**
 * @hidden
 * @deprecated
 */
export const showDropDown = 'showDropDown';
/**
 * @hidden
 * @deprecated
 */
export const closeTooltip = 'closeTooltip';
/**
 * @hidden
 * @deprecated
 */
export const autoResize = 'autoResize';
/**
 * @hidden
 * @deprecated
 */
export const onAIAssistant = 'onAIAssistant';
/**
 * @hidden
 * @deprecated
 */
export const menuItemselected = 'menuItemselected';
/**
 * @hidden
 * @deprecated
 */
export const menuBeforeOpen = 'menuBeforeOpen';
/**
 * @hidden
 * @deprecated
 */
export const menuBeforeClose = 'menuBeforeClose';
/**
 * @hidden
 * @deprecated
 */
export const selectionChangeMouseUp = 'selectionChangeMouseUp';
/**
 * @hidden
 * @deprecated
 */
export const blockEmptyNodes = `address:empty, article:empty, aside:empty, blockquote:empty,
 details:empty, dd:empty, div:empty, dl:empty, dt:empty, fieldset:empty, footer:empty,form:empty, h1:empty,
 h2:empty, h3:empty, h4:empty, h5:empty, h6:empty, header:empty, hgroup:empty, li:empty, main:empty, nav:empty,
 noscript:empty, output:empty, p:empty, pre:empty, section:empty, td:empty, th:empty`;
/**
 * @hidden
 * @deprecated
 */
export const inlineEmptyNodes = `a:empty, abbr:empty, acronym:empty, b:empty, bdi:empty, bdo:empty, big:empty, button:empty,
canvas:empty, cite:empty, code:empty, data:empty, datalist:empty, del:empty, dfn:empty, em:empty, font:empty, i:empty, iframe:empty,
ins:empty, kbd:empty, label:empty, map:empty, mark:empty, meter:empty, noscript:empty, object:empty, output:empty, picture:empty, progress:empty,
q:empty, ruby:empty, s:empty, samp:empty, script:empty, select:empty, slot:empty, small:empty, span:empty, strong:empty, strike:empty, sub:empty, sup:empty, svg:empty,
template:empty, textarea:empty, time:empty, u:empty, tt:empty, var:empty, wbr:empty`;
/**
 * @hidden
 * @deprecated
 */
export const onHandleFontsizeChange = 'onHandleFontsizeChange';
/**
 * @hidden
 * @deprecated
 */
export const preventQuickToolbarClose = 'preventQuickToolbarClose';
/**
 * @hidden
 * @deprecated
 */
export const selectionChanged = 'selectionChanged';
/**
 * @hidden
 * @deprecated
 */
export const wordImporting = 'wordImporting';
/**
 * @hidden
 * @deprecated
 */
export const documentExporting = 'documentExporting';
